import React, { memo } from 'react';

import { Avatar } from '@sravni/react-design-system';
import { PartnerBadge } from '@sravni/react-ugc/lib/PartnerBadge';

interface IProps {
  logoSrc: string;
  isPartner: boolean;
  size?: 36 | 44 | 52 | 60;
}

export const OrganizationLogo = memo<IProps>(({ logoSrc, isPartner, size = 60 }) => (
  <div>
    {isPartner ? (
      <PartnerBadge>
        <Avatar src={logoSrc} size={size} />
      </PartnerBadge>
    ) : (
      <Avatar src={logoSrc} size={size} />
    )}
  </div>
));
